import { Parser, useQueryState } from 'nuqs'
import { useEffect, useRef } from 'react'

export function useDebouncedQueryState<T>(
  key: string,
  parser: Parser<T>,
  wait: number,
) {
  const [value, setQueryValue] = useQueryState(key, parser)
  const timeoutRef = useRef<number | null>(null)

  const clearTimeout = () => window.clearTimeout(timeoutRef.current!)
  useEffect(() => clearTimeout, [])

  const debouncedSetValue = (newValue: Parameters<typeof setQueryValue>[0]) => {
    clearTimeout()
    timeoutRef.current = window.setTimeout(() => {
      setQueryValue(newValue)
    }, wait)
  }

  return [String(value), debouncedSetValue] as const
}
